'use client';

import EtherOrMinimap from '../../src/@ether/UI/router/EtherOrMinimap';

export default function CatchAllClient() {
  return <EtherOrMinimap />;
}
